var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 966,
    height: 2048,
    contentScriptType: "text/ecmascript",
    viewBox: "45 0 966 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627 1504q0 13-10 23l-50 50q-10 10-23 10c-13 0-16.333-3.333-23-10L55 1111q-10-10-10-23c0-13 3.333-16.333 10-23l466-466q10-10 23-10c13 0 16.333 3.333 23 10l50 50q10 10 10 23c0 13-3.333 16.333-10 23l-393 393 393 393q10 10 10 23m384 0q0 13-10 23l-50 50q-10 10-23 10c-13 0-16.333-3.333-23-10l-466-466q-10-10-10-23c0-13 3.333-16.333 10-23l466-466q10-10 23-10c13 0 16.333 3.333 23 10l50 50q10 10 10 23c0 13-3.333 16.333-10 23l-393 393 393 393q10 10 10 23"
  })));
};
export default SvgIconChevronLeft;